import React, { useState } from 'react';
import { MapContainer, TileLayer, CircleMarker, Popup } from 'react-leaflet';
import { StoreDetailPanel } from './StoreDetailPanel';
import { MapLegend } from './MapLegend';
// Status colors
const statusColors = {
  success: '#22c55e',
  warning: '#eab308',
  danger: '#ef4444'
};
// Extended Mock Data - 95 stores across Germany
const stores = [
// Nord
{
  id: 1,
  name: 'EDEKA Center Hamburg-Hafencity',
  lat: 53.5411,
  lng: 9.9937,
  score: 4.6,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Hamburg, Hafencity'
}, {
  id: 2,
  name: 'EDEKA Neukauf Hamburg-Altona',
  lat: 53.5511,
  lng: 9.9337,
  score: 4.2,
  status: 'warning',
  type: 'EDEKA Neukauf',
  address: 'Hamburg, Altona'
}, {
  id: 3,
  name: 'EDEKA aktiv markt Hamburg-Wandsbek',
  lat: 53.5711,
  lng: 10.0537,
  score: 3.9,
  status: 'warning',
  type: 'EDEKA aktiv markt',
  address: 'Hamburg, Wandsbek'
}, {
  id: 4,
  name: 'EDEKA Center Kiel',
  lat: 54.3233,
  lng: 10.1228,
  score: 4.7,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Kiel, Innenstadt'
}, {
  id: 5,
  name: 'EDEKA Neukauf Lübeck',
  lat: 53.8655,
  lng: 10.6866,
  score: 4.4,
  status: 'success',
  type: 'EDEKA Neukauf',
  address: 'Lübeck, Altstadt'
}, {
  id: 6,
  name: 'EDEKA Bremen-Mitte',
  lat: 53.0793,
  lng: 8.8017,
  score: 3.6,
  status: 'warning',
  type: 'EDEKA aktiv markt',
  address: 'Bremen, Mitte'
}, {
  id: 7,
  name: 'EDEKA Center Oldenburg',
  lat: 53.1435,
  lng: 8.2146,
  score: 4.5,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Oldenburg, Zentrum'
}, {
  id: 8,
  name: 'EDEKA Rostock',
  lat: 54.0924,
  lng: 12.0991,
  score: 3.2,
  status: 'danger',
  type: 'EDEKA Neukauf',
  address: 'Rostock, Stadtmitte'
},
// Berlin & Brandenburg
{
  id: 9,
  name: 'EDEKA Center Berlin-Mitte',
  lat: 52.52,
  lng: 13.405,
  score: 4.3,
  status: 'warning',
  type: 'EDEKA Center',
  address: 'Berlin, Mitte'
}, {
  id: 10,
  name: 'EDEKA Neukauf Berlin-Kreuzberg',
  lat: 52.4934,
  lng: 13.4234,
  score: 3.8,
  status: 'warning',
  type: 'EDEKA Neukauf',
  address: 'Berlin, Kreuzberg'
}, {
  id: 11,
  name: 'EDEKA Berlin-Prenzlauer Berg',
  lat: 52.5388,
  lng: 13.4244,
  score: 4.6,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Berlin, Prenzlauer Berg'
}, {
  id: 12,
  name: 'EDEKA Berlin-Charlottenburg',
  lat: 52.5166,
  lng: 13.3042,
  score: 4.1,
  status: 'warning',
  type: 'EDEKA Neukauf',
  address: 'Berlin, Charlottenburg'
}, {
  id: 13,
  name: 'EDEKA Potsdam',
  lat: 52.3906,
  lng: 13.0645,
  score: 4.8,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Potsdam, Innenstadt'
},
// NRW
{
  id: 14,
  name: 'EDEKA Köln-Ehrenfeld',
  lat: 50.9375,
  lng: 6.9203,
  score: 3.2,
  status: 'danger',
  type: 'EDEKA aktiv markt',
  address: 'Köln, Ehrenfeld'
}, {
  id: 15,
  name: 'EDEKA Center Köln-Deutz',
  lat: 50.9375,
  lng: 6.9803,
  score: 4.5,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Köln, Deutz'
}, {
  id: 16,
  name: 'EDEKA Düsseldorf-Bilk',
  lat: 51.2077,
  lng: 6.7735,
  score: 4.3,
  status: 'warning',
  type: 'EDEKA Center',
  address: 'Düsseldorf, Bilk'
}, {
  id: 17,
  name: 'EDEKA Düsseldorf-Oberkassel',
  lat: 51.2377,
  lng: 6.7435,
  score: 4.7,
  status: 'success',
  type: 'EDEKA Neukauf',
  address: 'Düsseldorf, Oberkassel'
}, {
  id: 18,
  name: 'EDEKA Essen-Rüttenscheid',
  lat: 51.4356,
  lng: 7.0016,
  score: 3.7,
  status: 'warning',
  type: 'EDEKA aktiv markt',
  address: 'Essen, Rüttenscheid'
}, {
  id: 19,
  name: 'EDEKA Dortmund-Innenstadt',
  lat: 51.5136,
  lng: 7.4653,
  score: 3.4,
  status: 'danger',
  type: 'EDEKA Neukauf',
  address: 'Dortmund, Innenstadt'
}, {
  id: 20,
  name: 'EDEKA Center Münster',
  lat: 51.9607,
  lng: 7.6261,
  score: 4.6,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Münster, Zentrum'
}, {
  id: 21,
  name: 'EDEKA Duisburg-Mitte',
  lat: 51.4344,
  lng: 6.7623,
  score: 2.9,
  status: 'danger',
  type: 'EDEKA Neukauf',
  address: 'Duisburg, Mitte'
}, {
  id: 22,
  name: 'EDEKA Bonn-Bad Godesberg',
  lat: 50.6851,
  lng: 7.1531,
  score: 4.4,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Bonn, Bad Godesberg'
}, {
  id: 23,
  name: 'EDEKA Wuppertal',
  lat: 51.2562,
  lng: 7.1508,
  score: 3.8,
  status: 'warning',
  type: 'EDEKA aktiv markt',
  address: 'Wuppertal, Elberfeld'
},
// Hessen & Rheinland-Pfalz
{
  id: 24,
  name: 'EDEKA Frankfurt-Sachsenhausen',
  lat: 50.1009,
  lng: 8.6821,
  score: 4.2,
  status: 'warning',
  type: 'EDEKA Center',
  address: 'Frankfurt, Sachsenhausen'
}, {
  id: 25,
  name: 'EDEKA Frankfurt-Nordend',
  lat: 50.1309,
  lng: 8.6921,
  score: 4.6,
  status: 'success',
  type: 'EDEKA Neukauf',
  address: 'Frankfurt, Nordend'
}, {
  id: 26,
  name: 'EDEKA Wiesbaden',
  lat: 50.0782,
  lng: 8.2398,
  score: 4.1,
  status: 'warning',
  type: 'EDEKA Center',
  address: 'Wiesbaden, Innenstadt'
}, {
  id: 27,
  name: 'EDEKA Mainz',
  lat: 49.9929,
  lng: 8.2473,
  score: 3.3,
  status: 'danger',
  type: 'EDEKA aktiv markt',
  address: 'Mainz, Altstadt'
}, {
  id: 28,
  name: 'EDEKA Kassel',
  lat: 51.3127,
  lng: 9.4797,
  score: 4.5,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Kassel, Mitte'
},
// Bayern
{
  id: 29,
  name: 'EDEKA Center München-Schwabing',
  lat: 48.1551,
  lng: 11.582,
  score: 4.8,
  status: 'success',
  type: 'EDEKA Center',
  address: 'München, Schwabing'
}, {
  id: 30,
  name: 'EDEKA München-Haidhausen',
  lat: 48.1251,
  lng: 11.602,
  score: 4.4,
  status: 'success',
  type: 'EDEKA Neukauf',
  address: 'München, Haidhausen'
}, {
  id: 31,
  name: 'EDEKA München-Pasing',
  lat: 48.1451,
  lng: 11.462,
  score: 3.9,
  status: 'warning',
  type: 'EDEKA aktiv markt',
  address: 'München, Pasing'
}, {
  id: 32,
  name: 'EDEKA Nürnberg-Gostenhof',
  lat: 49.4521,
  lng: 11.0567,
  score: 3.1,
  status: 'danger',
  type: 'EDEKA Neukauf',
  address: 'Nürnberg, Gostenhof'
}, {
  id: 33,
  name: 'EDEKA Center Nürnberg-Zentrum',
  lat: 49.4521,
  lng: 11.0967,
  score: 4.5,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Nürnberg, Zentrum'
}, {
  id: 34,
  name: 'EDEKA Augsburg',
  lat: 48.3705,
  lng: 10.8978,
  score: 4.3,
  status: 'warning',
  type: 'EDEKA Center',
  address: 'Augsburg, Innenstadt'
}, {
  id: 35,
  name: 'EDEKA Regensburg',
  lat: 49.0134,
  lng: 12.1016,
  score: 4.7,
  status: 'success',
  type: 'EDEKA Neukauf',
  address: 'Regensburg, Altstadt'
}, {
  id: 36,
  name: 'EDEKA Würzburg',
  lat: 49.7913,
  lng: 9.9534,
  score: 4.0,
  status: 'warning',
  type: 'EDEKA aktiv markt',
  address: 'Würzburg, Sanderau'
},
// Baden-Württemberg
{
  id: 37,
  name: 'EDEKA Stuttgart-West',
  lat: 48.7758,
  lng: 9.1629,
  score: 4.5,
  status: 'success',
  type: 'EDEKA Neukauf',
  address: 'Stuttgart, West'
}, {
  id: 38,
  name: 'EDEKA Center Stuttgart-Mitte',
  lat: 48.7758,
  lng: 9.1829,
  score: 4.2,
  status: 'warning',
  type: 'EDEKA Center',
  address: 'Stuttgart, Mitte'
}, {
  id: 39,
  name: 'EDEKA Karlsruhe',
  lat: 49.0069,
  lng: 8.4037,
  score: 4.6,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Karlsruhe, Innenstadt'
}, {
  id: 40,
  name: 'EDEKA Mannheim',
  lat: 49.4875,
  lng: 8.466,
  score: 3.5,
  status: 'warning',
  type: 'EDEKA Neukauf',
  address: 'Mannheim, Quadrate'
}, {
  id: 41,
  name: 'EDEKA Freiburg',
  lat: 47.999,
  lng: 7.8421,
  score: 4.8,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Freiburg, Altstadt'
}, {
  id: 42,
  name: 'EDEKA Heidelberg',
  lat: 49.3988,
  lng: 8.6724,
  score: 4.4,
  status: 'success',
  type: 'EDEKA Neukauf',
  address: 'Heidelberg, Altstadt'
}, {
  id: 43,
  name: 'EDEKA Ulm',
  lat: 48.4011,
  lng: 9.9876,
  score: 3.8,
  status: 'warning',
  type: 'EDEKA aktiv markt',
  address: 'Ulm, Innenstadt'
},
// Sachsen & Thüringen
{
  id: 44,
  name: 'EDEKA Leipzig-Zentrum',
  lat: 51.3397,
  lng: 12.3731,
  score: 3.9,
  status: 'warning',
  type: 'EDEKA aktiv markt',
  address: 'Leipzig, Zentrum'
}, {
  id: 45,
  name: 'EDEKA Center Leipzig-Süd',
  lat: 51.3097,
  lng: 12.3731,
  score: 4.5,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Leipzig, Süd'
}, {
  id: 46,
  name: 'EDEKA Dresden-Altstadt',
  lat: 51.0504,
  lng: 13.7373,
  score: 4.7,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Dresden, Altstadt'
}, {
  id: 47,
  name: 'EDEKA Dresden-Neustadt',
  lat: 51.0704,
  lng: 13.7473,
  score: 4.1,
  status: 'warning',
  type: 'EDEKA Neukauf',
  address: 'Dresden, Neustadt'
}, {
  id: 48,
  name: 'EDEKA Erfurt',
  lat: 50.9787,
  lng: 11.0328,
  score: 4.3,
  status: 'warning',
  type: 'EDEKA Center',
  address: 'Erfurt, Innenstadt'
}, {
  id: 49,
  name: 'EDEKA Jena',
  lat: 50.9271,
  lng: 11.5892,
  score: 4.6,
  status: 'success',
  type: 'EDEKA Neukauf',
  address: 'Jena, Zentrum'
},
// Niedersachsen
{
  id: 50,
  name: 'EDEKA Hannover-List',
  lat: 52.3859,
  lng: 9.752,
  score: 4.4,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Hannover, List'
}, {
  id: 51,
  name: 'EDEKA Hannover-Linden',
  lat: 52.3659,
  lng: 9.712,
  score: 3.7,
  status: 'warning',
  type: 'EDEKA Neukauf',
  address: 'Hannover, Linden'
}, {
  id: 52,
  name: 'EDEKA Braunschweig',
  lat: 52.2689,
  lng: 10.5268,
  score: 4.2,
  status: 'warning',
  type: 'EDEKA Center',
  address: 'Braunschweig, Innenstadt'
}, {
  id: 53,
  name: 'EDEKA Göttingen',
  lat: 51.5413,
  lng: 9.9158,
  score: 4.8,
  status: 'success',
  type: 'EDEKA Neukauf',
  address: 'Göttingen, Zentrum'
}, {
  id: 54,
  name: 'EDEKA Osnabrück',
  lat: 52.2799,
  lng: 8.0472,
  score: 3.4,
  status: 'danger',
  type: 'EDEKA aktiv markt',
  address: 'Osnabrück, Innenstadt'
}, {
  id: 55,
  name: 'EDEKA Wolfsburg',
  lat: 52.4227,
  lng: 10.7865,
  score: 4.0,
  status: 'warning',
  type: 'EDEKA Center',
  address: 'Wolfsburg, Zentrum'
},
// Neue Standorte - Schleswig-Holstein & Mecklenburg-Vorpommern
{
  id: 56,
  name: 'EDEKA Flensburg',
  lat: 54.7937,
  lng: 9.4469,
  score: 4.3,
  status: 'warning',
  type: 'EDEKA Center',
  address: 'Flensburg, Zentrum'
}, {
  id: 57,
  name: 'EDEKA Neumünster',
  lat: 54.0712,
  lng: 9.9819,
  score: 4.5,
  status: 'success',
  type: 'EDEKA Neukauf',
  address: 'Neumünster, Innenstadt'
}, {
  id: 58,
  name: 'EDEKA Schwerin',
  lat: 53.6355,
  lng: 11.4012,
  score: 3.8,
  status: 'warning',
  type: 'EDEKA Center',
  address: 'Schwerin, Altstadt'
}, {
  id: 59,
  name: 'EDEKA Stralsund',
  lat: 54.3096,
  lng: 13.0818,
  score: 4.1,
  status: 'warning',
  type: 'EDEKA Neukauf',
  address: 'Stralsund, Altstadt'
}, {
  id: 60,
  name: 'EDEKA Greifswald',
  lat: 54.0865,
  lng: 13.3923,
  score: 4.6,
  status: 'success',
  type: 'EDEKA aktiv markt',
  address: 'Greifswald, Zentrum'
},
// Neue Standorte - Berlin Umland
{
  id: 61,
  name: 'EDEKA Berlin-Spandau',
  lat: 52.5344,
  lng: 13.1997,
  score: 4.0,
  status: 'warning',
  type: 'EDEKA Center',
  address: 'Berlin, Spandau'
}, {
  id: 62,
  name: 'EDEKA Berlin-Steglitz',
  lat: 52.4567,
  lng: 13.3289,
  score: 4.7,
  status: 'success',
  type: 'EDEKA Neukauf',
  address: 'Berlin, Steglitz'
}, {
  id: 63,
  name: 'EDEKA Berlin-Pankow',
  lat: 52.5677,
  lng: 13.4089,
  score: 3.5,
  status: 'warning',
  type: 'EDEKA aktiv markt',
  address: 'Berlin, Pankow'
}, {
  id: 64,
  name: 'EDEKA Cottbus',
  lat: 51.7606,
  lng: 14.3342,
  score: 4.2,
  status: 'warning',
  type: 'EDEKA Center',
  address: 'Cottbus, Zentrum'
}, {
  id: 65,
  name: 'EDEKA Frankfurt (Oder)',
  lat: 52.3471,
  lng: 14.5506,
  score: 3.9,
  status: 'warning',
  type: 'EDEKA Neukauf',
  address: 'Frankfurt (Oder), Mitte'
},
// Neue Standorte - NRW Erweiterung
{
  id: 66,
  name: 'EDEKA Aachen',
  lat: 50.7753,
  lng: 6.0839,
  score: 4.4,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Aachen, Innenstadt'
}, {
  id: 67,
  name: 'EDEKA Krefeld',
  lat: 51.3388,
  lng: 6.5853,
  score: 3.6,
  status: 'warning',
  type: 'EDEKA Neukauf',
  address: 'Krefeld, Zentrum'
}, {
  id: 68,
  name: 'EDEKA Mönchengladbach',
  lat: 51.1805,
  lng: 6.4428,
  score: 4.1,
  status: 'warning',
  type: 'EDEKA aktiv markt',
  address: 'Mönchengladbach, Rheydt'
}, {
  id: 69,
  name: 'EDEKA Bielefeld',
  lat: 52.0302,
  lng: 8.5325,
  score: 4.5,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Bielefeld, Mitte'
}, {
  id: 70,
  name: 'EDEKA Paderborn',
  lat: 51.7189,
  lng: 8.7575,
  score: 4.3,
  status: 'warning',
  type: 'EDEKA Neukauf',
  address: 'Paderborn, Zentrum'
}, {
  id: 71,
  name: 'EDEKA Siegen',
  lat: 50.8748,
  lng: 8.0243,
  score: 3.8,
  status: 'warning',
  type: 'EDEKA aktiv markt',
  address: 'Siegen, Innenstadt'
}, {
  id: 72,
  name: 'EDEKA Hagen',
  lat: 51.3671,
  lng: 7.4633,
  score: 3.2,
  status: 'danger',
  type: 'EDEKA Neukauf',
  address: 'Hagen, Zentrum'
},
// Neue Standorte - Rheinland-Pfalz & Saarland
{
  id: 73,
  name: 'EDEKA Koblenz',
  lat: 50.3569,
  lng: 7.5889,
  score: 4.6,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Koblenz, Altstadt'
}, {
  id: 74,
  name: 'EDEKA Trier',
  lat: 49.7596,
  lng: 6.6439,
  score: 4.2,
  status: 'warning',
  type: 'EDEKA Neukauf',
  address: 'Trier, Innenstadt'
}, {
  id: 75,
  name: 'EDEKA Kaiserslautern',
  lat: 49.4447,
  lng: 7.7689,
  score: 3.9,
  status: 'warning',
  type: 'EDEKA aktiv markt',
  address: 'Kaiserslautern, Zentrum'
}, {
  id: 76,
  name: 'EDEKA Ludwigshafen',
  lat: 49.4774,
  lng: 8.4452,
  score: 3.4,
  status: 'danger',
  type: 'EDEKA Neukauf',
  address: 'Ludwigshafen, Mitte'
}, {
  id: 77,
  name: 'EDEKA Saarbrücken',
  lat: 49.2354,
  lng: 6.9965,
  score: 4.4,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Saarbrücken, St. Johann'
},
// Neue Standorte - Bayern Erweiterung
{
  id: 78,
  name: 'EDEKA Ingolstadt',
  lat: 48.7665,
  lng: 11.4258,
  score: 4.5,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Ingolstadt, Zentrum'
}, {
  id: 79,
  name: 'EDEKA Erlangen',
  lat: 49.5897,
  lng: 11.0078,
  score: 4.7,
  status: 'success',
  type: 'EDEKA Neukauf',
  address: 'Erlangen, Innenstadt'
}, {
  id: 80,
  name: 'EDEKA Fürth',
  lat: 49.4774,
  lng: 10.9886,
  score: 4.0,
  status: 'warning',
  type: 'EDEKA aktiv markt',
  address: 'Fürth, Zentrum'
}, {
  id: 81,
  name: 'EDEKA Bamberg',
  lat: 49.8988,
  lng: 10.9028,
  score: 4.8,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Bamberg, Altstadt'
}, {
  id: 82,
  name: 'EDEKA Bayreuth',
  lat: 49.9456,
  lng: 11.5713,
  score: 4.1,
  status: 'warning',
  type: 'EDEKA Neukauf',
  address: 'Bayreuth, Innenstadt'
}, {
  id: 83,
  name: 'EDEKA Passau',
  lat: 48.5665,
  lng: 13.4319,
  score: 4.3,
  status: 'warning',
  type: 'EDEKA aktiv markt',
  address: 'Passau, Altstadt'
}, {
  id: 84,
  name: 'EDEKA Rosenheim',
  lat: 47.8561,
  lng: 12.1289,
  score: 4.6,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Rosenheim, Zentrum'
},
// Neue Standorte - Baden-Württemberg Erweiterung
{
  id: 85,
  name: 'EDEKA Pforzheim',
  lat: 48.8922,
  lng: 8.6947,
  score: 3.7,
  status: 'warning',
  type: 'EDEKA Neukauf',
  address: 'Pforzheim, Innenstadt'
}, {
  id: 86,
  name: 'EDEKA Reutlingen',
  lat: 48.4919,
  lng: 9.2108,
  score: 4.4,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Reutlingen, Zentrum'
}, {
  id: 87,
  name: 'EDEKA Tübingen',
  lat: 48.5216,
  lng: 9.0576,
  score: 4.9,
  status: 'success',
  type: 'EDEKA Neukauf',
  address: 'Tübingen, Altstadt'
}, {
  id: 88,
  name: 'EDEKA Heilbronn',
  lat: 49.1427,
  lng: 9.2109,
  score: 4.0,
  status: 'warning',
  type: 'EDEKA aktiv markt',
  address: 'Heilbronn, Innenstadt'
}, {
  id: 89,
  name: 'EDEKA Konstanz',
  lat: 47.6633,
  lng: 9.1759,
  score: 4.7,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Konstanz, Altstadt'
},
// Neue Standorte - Sachsen-Anhalt & Sachsen
{
  id: 90,
  name: 'EDEKA Magdeburg',
  lat: 52.1205,
  lng: 11.6276,
  score: 4.2,
  status: 'warning',
  type: 'EDEKA Center',
  address: 'Magdeburg, Zentrum'
}, {
  id: 91,
  name: 'EDEKA Halle (Saale)',
  lat: 51.4828,
  lng: 11.9697,
  score: 3.8,
  status: 'warning',
  type: 'EDEKA Neukauf',
  address: 'Halle, Innenstadt'
}, {
  id: 92,
  name: 'EDEKA Chemnitz',
  lat: 50.8278,
  lng: 12.9214,
  score: 4.5,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Chemnitz, Zentrum'
}, {
  id: 93,
  name: 'EDEKA Zwickau',
  lat: 50.7189,
  lng: 12.4964,
  score: 4.1,
  status: 'warning',
  type: 'EDEKA aktiv markt',
  address: 'Zwickau, Innenstadt'
}, {
  id: 94,
  name: 'EDEKA Plauen',
  lat: 50.4942,
  lng: 12.1378,
  score: 3.6,
  status: 'warning',
  type: 'EDEKA Neukauf',
  address: 'Plauen, Zentrum'
}, {
  id: 95,
  name: 'EDEKA Dessau',
  lat: 51.8313,
  lng: 12.2414,
  score: 4.4,
  status: 'success',
  type: 'EDEKA Center',
  address: 'Dessau, Innenstadt'
}];
// Export stores for use in other components
export { stores };
export function StoreMap() {
  const [selectedStore, setSelectedStore] = useState<any>(null);
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const handleMarkerClick = (store: any) => {
    setSelectedStore(store);
    setIsPanelOpen(true);
  };
  return <div className="relative w-full h-full bg-gray-100 overflow-hidden" data-id="element-149">
      <MapContainer center={[51.1657, 10.4515]} zoom={6.5} style={{
      height: '100%',
      width: '100%'
    }} zoomControl={true} data-id="element-150">
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" data-id="element-151" />

        {stores.map(store => <CircleMarker key={store.id} center={[store.lat, store.lng]} radius={10} pathOptions={{
        fillColor: statusColors[store.status as keyof typeof statusColors],
        fillOpacity: 0.9,
        color: '#ffffff',
        weight: 3
      }} eventHandlers={{
        click: () => handleMarkerClick(store)
      }} data-id="element-152">
            <Popup data-id="element-153">
              <div className="text-sm" data-id="element-154">
                <strong data-id="element-155">{store.name}</strong>
                <br data-id="element-156" />
                Bewertung: {store.score} ⭐
              </div>
            </Popup>
          </CircleMarker>)}
      </MapContainer>

      <MapLegend data-id="element-157" />

      <StoreDetailPanel isOpen={isPanelOpen} onClose={() => setIsPanelOpen(false)} store={selectedStore} data-id="element-158" />
    </div>;
}